<template>
    <div class="bg-color rounded-5 p-5">
        <div class="w-100 rounded-4">
            <div
                class="d-flex justify-content-between"
                style="background: rgb(241, 247, 255); border-radius: 27px 27px 0 0"
            >
                <div class="flex align-items-center list-page-header">
                    <h1 class="px-5 py-3 page-heading">Street Team Events</h1>
                </div>
                <div class="d-flex align-items-center gap-2" style="margin-right: 10px">
                    <button class="button secondary" @click="showImportModal = true">
                        <span class="material-icons-outlined" style="font-size:16px; vertical-align:middle">upload_file</span>
                        Import CSV
                    </button>
                    <button class="text-button no-bg weight-600" style="background: transparent; padding: 0">
                        <router-link class="text-link margin-0" :to="{ name: 'StreetTeamEventEdit' }">
                            <img src="@/assets/px/add.png" alt="" style="height: 20px" /> Create New Event
                        </router-link>
                    </button>
                </div>
            </div>

            <div class="d-flex align-items-center gap-3 bg-white px-4 py-3" style="width: 82vw; border-bottom: 1px solid #e9ecef">
                <div style="width: 280px; min-width: 200px">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        placeholder="Search name, location, dashboard..."
                        v-model="searchKeyword"
                        @input="onFilterChange"
                    />
                </div>
                <div class="d-flex align-items-center gap-2">
                    <label class="mb-0 text-nowrap" style="font-size: 0.85rem; color: #6c757d">From</label>
                    <input
                        type="date"
                        class="form-control form-control-sm"
                        style="width: 150px"
                        v-model="dateFrom"
                        @change="onFilterChange"
                    />
                </div>
                <div class="d-flex align-items-center gap-2">
                    <label class="mb-0 text-nowrap" style="font-size: 0.85rem; color: #6c757d">To</label>
                    <input
                        type="date"
                        class="form-control form-control-sm"
                        style="width: 150px"
                        v-model="dateTo"
                        @change="onFilterChange"
                    />
                </div>
                <button
                    v-if="searchKeyword || dateFrom || dateTo"
                    class="btn btn-sm btn-outline-secondary"
                    @click="clearFilters"
                >
                    Clear
                </button>
            </div>

            <div v-if="isLoading" class="w-100 bg-white d-grid justify-content-center align-items-center py-5" style="min-height: 400px">
                <div class="spinner-border text-primary" role="status"></div>
            </div>

            <div
                v-else-if="events_list && events_list.length > 0"
                class="dashboard-list-table profile-listing-body pb-2"
                style="width: 82vw"
            >
                <b-table
                    id="street-team-table"
                    :items="events_list"
                    :fields="fields"
                    bordered
                    responsive
                >
                    <template #cell(s_no)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template #cell(name)="row">
                        <span :id="`eventName-${row.index}`" class="column-ellipsis">
                            {{ row.item.name }}
                        </span>
                        <b-tooltip :target="`eventName-${row.index}`" triggers="hover" placement="bottom">
                            {{ row.item.name }}
                        </b-tooltip>
                    </template>
                    <template #cell(location)="row">
                        {{ row.item.location }}
                    </template>
                    <template #cell(event_date)="row">
                        {{ row.item.event_date ? row.item.event_date.substring(0, 10) : '—' }}
                    </template>
                    <template #cell(dashboard_id)="row">
                        {{ dashboardMap[row.item.dashboard_id] || '—' }}
                    </template>
                    <template #cell(member_dashboard_id)="row">
                        {{ dashboardMap[row.item.member_dashboard_id] || '—' }}
                    </template>
                    <template #cell(status)="row">
                        <span :class="`status-badge status-${row.item.status}`">
                            {{ row.item.status }}
                        </span>
                    </template>
                    <template #cell(action)="row">
                        <div class="d-flex justify-content-center align-items-center gap-2">
                            <ejs-tooltip
                                class="tooltipcontainer"
                                content="Edit"
                                target="#target"
                                cssClass="customtooltip"
                            >
                                <img
                                    src="@/assets/px/edit-icon.png"
                                    alt=""
                                    style="height: 20px; cursor: pointer"
                                    id="target"
                                    @click="editEvent(row.item)"
                                />
                            </ejs-tooltip>
                            <ejs-tooltip
                                class="tooltipcontainer"
                                content="Delete"
                                target="#target"
                                cssClass="customtooltip"
                            >
                                <img
                                    src="@/assets/px/delete-icon.png"
                                    alt=""
                                    style="height: 20px; cursor: pointer"
                                    id="target"
                                    @click="showDeleteAlertPopUp(row.item.id)"
                                />
                            </ejs-tooltip>
                        </div>
                    </template>
                </b-table>
                <div class="b-table-pagination">
                    <div class="pagination-count-per-page">
                        <div class="pagination-number-per-page">
                            <div>
                                <span>Per page:</span>
                            </div>
                            <div>
                                <select @change="changeCountPerPage" :value="perPage">
                                    <option v-for="item in perPageOptions" :key="item" :value="item">
                                        {{ item }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <b-pagination
                        align="right"
                        :value="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        aria-controls="street-team-table"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
            </div>

            <div class="w-100 bg-white" v-else>
                <div class="d-grid justify-content-center align-items-center py-5" style="min-height: 400px">
                    <h4>No events found</h4>
                </div>
            </div>

            <div class="profile-delete-modal">
                <AlertDeleteEventTemplate
                    v-if="showDeleteAlert"
                    :open="showDeleteAlert"
                    @cancel="showDeleteAlert = false"
                    @handleDelete="handleDelete"
                />
            </div>

            <ImportEventsModal
                v-if="showImportModal"
                :open="showImportModal"
                @close="showImportModal = false"
                @imported="onImported"
            />
        </div>
    </div>
</template>

<script>
    import AlertDeleteEventTemplate from './delete_event_alert.vue';
    import ImportEventsModal from './ImportEventsModal.vue';
    import { streetTeam, dashboardBuilder } from '@/util/apiRequests';

    export default {
        name: 'StreetTeamEventsList',
        components: { AlertDeleteEventTemplate, ImportEventsModal },
        data() {
            return {
                events_list: [],
                dashboardMap: {},
                isLoading: true,
                showDeleteAlert: false,
                showImportModal: false,
                indexTodelete: null,
                searchKeyword: '',
                dateFrom: '',
                dateTo: '',
                searchDebounce: null,
                fields: [
                    { key: 's_no', label: 'S NO.', thStyle: { 'padding-left': '0 !important' }, class: 'table-col' },
                    { key: 'name', label: 'Event Name', class: 'table-col' },
                    { key: 'location', label: 'Location', class: 'table-col' },
                    { key: 'event_date', label: 'Date', class: 'table-col' },
                    { key: 'dashboard_id', label: 'ST Dashboard', class: 'table-col' },
                    { key: 'member_dashboard_id', label: 'Member Dashboard', class: 'table-col' },
                    { key: 'status', label: 'Status', class: 'table-col' },
                    { key: 'action', label: 'Action', class: 'action-sticky', stickyColumn: true, isRowHeader: true },
                ],
                totalRows: 0,
                perPageOptions: [5, 10, 20, 50, 100],
                currentPage: 1,
                perPage: 10,
            };
        },
        methods: {
            async loadDashboards() {
                try {
                    const res = await this.$api.get(dashboardBuilder.getAllTemplateList('completed', 'mobex-health-home'));
                    const list = res.data?.templateMetaList ?? [];
                    list.forEach((d) => {
                        this.dashboardMap[d.id] = d.dashboardName;
                    });
                } catch {
                    // non-critical, table still works without names
                }
            },
            async loadEvents() {
                try {
                    this.isLoading = true;
                    const params = {
                        page: this.currentPage,
                        limit: this.perPage,
                    };
                    if (this.searchKeyword) params.search = this.searchKeyword;
                    if (this.dateFrom) params.event_date_from = this.dateFrom;
                    if (this.dateTo) params.event_date_to = this.dateTo;
                    const res = await this.$api.get(streetTeam.getAll(), { params });
                    if (res.status >= 400) {
                        this.$toasted.error('Failed to load events.');
                        return;
                    }
                    const payload = res.data?.data ?? res.data ?? {};
                    this.events_list = payload.rows ?? [];
                    this.totalRows = payload.total_count ?? 0;
                } catch (err) {
                    this.$toasted.error('Failed to load events.');
                } finally {
                    this.isLoading = false;
                }
            },
            onFilterChange() {
                clearTimeout(this.searchDebounce);
                this.searchDebounce = setTimeout(() => {
                    this.currentPage = 1;
                    this.loadEvents();
                }, 400);
            },
            clearFilters() {
                this.searchKeyword = '';
                this.dateFrom = '';
                this.dateTo = '';
                this.currentPage = 1;
                this.loadEvents();
            },
            editEvent(item) {
                this.$router.push({
                    name: 'StreetTeamEventEdit',
                    query: { id: item.id },
                });
            },
            showDeleteAlertPopUp(id) {
                this.showDeleteAlert = true;
                this.indexTodelete = id;
            },
            async handleDelete() {
                try {
                    const res = await this.$api.delete(streetTeam.delete(this.indexTodelete));
                    if (res.status >= 400) {
                        this.$toasted.error('Failed to delete event.');
                        return;
                    }
                    this.$toasted.success('Event deleted successfully!');
                    await this.loadEvents();
                } catch (err) {
                    this.$toasted.error('Failed to delete event.');
                } finally {
                    this.showDeleteAlert = false;
                    this.indexTodelete = null;
                }
            },
            onPageChange(page) {
                this.currentPage = page;
                this.loadEvents();
            },
            changeCountPerPage({ target: { value } }) {
                this.perPage = Number(value);
                this.currentPage = 1;
                this.loadEvents();
            },
            onImported(count) {
                this.showImportModal = false;
                this.loadEvents();
                this.$toasted.success(`${count} event${count !== 1 ? 's' : ''} imported successfully!`);
            },
        },
        async created() {
            await this.loadDashboards();
            this.loadEvents();
        },
    };
</script>

<style scoped>
    .bg-color {
        background-color: rgba(255, 255, 255, 0.9);
    }

    .text-button a,
    .text-button a:hover,
    .text-button:hover {
        background-color: #5057c3;
        color: white;
        padding: 10px;
        border-radius: 10px;
    }

    .list-page-header {
        display: block;
        margin: 0;
        padding: 0;
        background: none;
    }

    .status-badge {
        padding: 3px 10px;
        border-radius: 12px;
        font-size: 0.8rem;
        text-transform: capitalize;
    }

    .status-active { background: #d4edda; color: #155724; }
    .status-inactive { background: #e2e3e5; color: #383d41; }
    .status-ended { background: #cce5ff; color: #004085; }
    .status-cancelled { background: #f8d7da; color: #721c24; }
</style>

<style>
    .dashboard-list-table table tbody tr > td:first-child {
        padding-left: 2.5em !important;
    }

    .dashboard-list-table .b-table-sticky-column:last-child {
        right: 0;
        min-width: 100px;
    }

    .dashboard-list-table .action-sticky {
        min-width: 150px;
        box-shadow: -10px 0px 10px 1px #aaaaaa;
    }

    .dashboard-list-table .table-col {
        max-width: 150px;
        text-overflow: ellipsis;
        text-wrap: nowrap;
    }
</style>
